import { makeAutoObservable } from 'mobx';
import { ModelValidator } from 'framework/mobx-integration';
import { AuthenticationFieldsStore } from 'areas/administration/authentication/types';
import {
	SmtpAuthentication,
	SmtpSecurityProtocol,
	smtpDefaultPorts,
} from 'areas/administration/authentication/smtp/types';

export class SmtpFieldsStore implements AuthenticationFieldsStore {
	model = new SmtpAuthentication();
	validator: ModelValidator<SmtpAuthentication>;

	constructor(public readOnly: boolean = false) {
		makeAutoObservable(this);
		this.validator = new ModelValidator(this.model);

		this.validator.required('host').required('port').between('port', 1, 65535);
	}

	load(record: Partial<SmtpAuthentication>) {
		Object.assign(this.model, new SmtpAuthentication(record));
	}

	changeSecurityProtocol(value: SmtpSecurityProtocol) {
		this.model.securityProtocol = value;
		this.model.port = smtpDefaultPorts[value];
	}

	clearStoredPassword() {
		this.model.password = '';
		this.model.hasPassword = false;
		this.model.clearPassword = true;
	}

	get payload() {
		return { ...this.model };
	}

	validate() {
		this.validator.validate();
		return this.validator.valid;
	}

	destroy() {
		this.validator.destroy();
	}
}
